import { ProgressBar } from '@/shared/ui/ProgressBar'
import { DefaultLayout } from '@/shared/ui/DefaultLayout'
import type { ProblemNewDraft } from '@/public/features/problem/types'
import { TOTAL_STEPS } from '@/public/features/problem/constants/problemNew'
import { Buttons, SubmitError } from '@/public/features/problem/ui/problemNew/parts'
import {
  Analyzing,
  Done,
  DoneButtons,
  RevisionButtons,
  RevisionNeeded,
} from '@/public/features/problem/ui/problemNew/Result'
import { StepCategory } from '@/public/features/problem/ui/problemNew/steps/StepCategory'
import { StepTarget } from '@/public/features/problem/ui/problemNew/steps/StepTarget'
import { StepStory } from '@/public/features/problem/ui/problemNew/steps/StepStory'
import { StepConsent } from '@/public/features/problem/ui/problemNew/steps/StepConsent'

export function ProblemNewMobile({ draft }: { draft: ProblemNewDraft }) {
  return (
    <DefaultLayout mobileTitle="시민 문제 등록" className="relative flex h-[100dvh] flex-col md:flex">
      {draft.stage === 'form' ? (
        <ProgressBar step={draft.step} total={TOTAL_STEPS} className="layout-body" />
      ) : null}

      <div
        data-scroll-root
        className={draft.step === TOTAL_STEPS ? 'layout-body flex min-h-0 flex-1 shrink-0 grow basis-0 flex-col overflow-y-auto px-4 pt-3 pb-4 gap-6' : 'layout-body flex min-h-0 flex-1 shrink-0 grow basis-0 flex-col overflow-y-auto px-4 pt-3 pb-4 gap-[45px]'}
      >
        {draft.stage === 'analyzing' ? (
          <Analyzing />
        ) : draft.stage === 'revision' ? (
          <RevisionNeeded reasons={draft.revisionReasons} />
        ) : draft.stage === 'done' ? (
          <Done editLinkPath={draft.editLinkPath} isEdit={draft.isEdit} />
        ) : (
          <Step draft={draft} />
        )}

        {draft.stage === 'form' ? <SubmitError error={draft.error} /> : null}
      </div>

      {draft.stage === 'form' ? (
        <Buttons draft={draft} />
      ) : draft.stage === 'revision' ? (
        <RevisionButtons onRevise={draft.goRevise} />
      ) : (
        <DoneButtons />
      )}
    </DefaultLayout>
  )
}

export function Step({ draft }: { draft: ProblemNewDraft }) {
  switch (draft.step) {
    case 1:
      return <StepCategory draft={draft} />
    case 2:
      return <StepTarget draft={draft} />
    case 3:
      return <StepStory draft={draft} />
    default:
      return <StepConsent draft={draft} />
  }
}
